import React, { FC } from 'react'
import { Modal } from '@wmgtech/legato'

import styles from './complete-modal.module.scss'
import Letter from './letter.png'

interface CompleteModalProps {
  title: string
  description: string | React.ReactNode
  isOpen: boolean
  onClose(): void
}

export const CompleteModal: FC<CompleteModalProps> = ({
  title,
  description,
  isOpen,
  onClose,
}) => {
  return (
    <Modal
      title=""
      isOpen={isOpen}
      onClose={onClose}
      className={styles.modal}
    >
      <img src={Letter} alt="Letter" className={styles.img} />
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </Modal>
  )
}
